<template>
  <div class="other-info">
    <div class="left">
      <div class="chart">
        <dv-charts :option="option1" v-if="zongTiJinDuDataLoaded"/>
      </div>
      <div class="desc">巡检完成{{ zongTiJinDuDataLoaded ? zongTiJinDu.wanChengShuLiang : 0 }}家 / 待巡检{{ zongTiJinDuDataLoaded ? zongTiJinDu.menDianShuLiang - zongTiJinDu.wanChengShuLiang : 0 }}家</div>
    </div>
    <div class="right">
      <div class="chart">
        <dv-charts :option="option2" v-if="jinQiRiXunJianQingKuangDataLoaded"/>
      </div>
      <div class="desc">近七日巡检情况</div>
    </div>
  </div>
</template>
<script>
import request from '@/util/request.js'

export default {
  data () {
    return {
      timer: null,
      zongTiJinDuDataLoaded: false,
      jinQiRiXunJianQingKuangDataLoaded: false,
      zongTiJinDu: null,
      option1: {
        series: [
          {
            type: 'gauge',
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 25,
            data: [
              {
                name: 'itemA',
                value: 0,
                gradient: ['#3e82e4', '#64a8f7', '#3498db']
              }
            ],
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            pointer: {
              show: false
            },
            dataItemStyle: {
              lineCap: 'round'
            },
            details: {
              show: true,
              formatter: '巡检完成 {value}%',
              style: {
                fill: '#1ed3e5',
                fontSize: 16
              }
            }
          }
        ]
      },
      option2: {
        title: {},
        grid: {
          bottom: 32
        },
        xAxis: {
          name: '日期',
          data: [/* '3/19', '3/20', '3/21', '3/22', '3/23', '3/24', '3/25' */],
          nameTextStyle: {
            fill: '#fff'
          },
          axisLabel: {
            style: {
              fill: '#fff'
            }
          }
        },
        yAxis: {
          name: '隐患数量',
          data: 'value',
          min: 0,
          axisLabel: {
            style: {
              fill: '#fff'
            }
          },
          nameTextStyle: {
            fill: '#fff'
          }
        },
        series: [
          {
            data: [/* 37, 29, 25, 30, 42, 35, 29 */],
            type: 'line',
            label: {
              show: true,
              style: {
                fill: '#fff'
              }
            },
            lineArea: {
              show: true,
              gradient: ['rgba(55, 162, 218, 0.6)', 'rgba(55, 162, 218, 0)']
            }
          }
        ]
      }
    }
  },
  created () {
    this.getZongTiJinDu()
    this.getJinQiXunJianQingKuang()
  },
  methods: {
    async getZongTiJinDu () {
      const res = await request.get('/common/zong-ti-jin-du')
      this.zongTiJinDu = res.data
      this.option1.series[0].data[0].value = Number(((this.zongTiJinDu.wanChengShuLiang / this.zongTiJinDu.menDianShuLiang) * 100).toFixed(2))
      this.zongTiJinDuDataLoaded = true
    },
    async getJinQiXunJianQingKuang () {
      const res = await request.get('/common/jin-qi-ri-xun-jian-qing-kuang')
      this.option2.xAxis.data = res.data.map(item => {
        return item.date
      })
      this.option2.series[0].data = res.data.map(item => {
        return item.count
      })
      this.jinQiRiXunJianQingKuangDataLoaded = true
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.getZongTiJinDu()
      this.getJinQiXunJianQingKuang()
    }, process.env.VUE_APP_DATA_REFRESH_INTERVAL)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<style lang="scss" scoped>
.other-info {
  height: 100%;
  display: flex;

  .left {
    width: 30%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .chart {
      flex-grow: 1;
    }

    .desc {
      color: #fff;
      text-align: center;
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }

  .right {
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .chart {
      flex-grow: 1;
    }

    .desc {
      color: #fff;
      text-align: center;
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }
}
</style>
